<avs-devices-table
  class="h-full"
  [config]="{
    largePlaceholder: false,
    stickyColumns: false,
    zoomControls: false,
  }"
  [displayedColumns]="columns"
  [filters]="filters()"
  tableId="devices-widget"
/>
